/** PDF containing the real sample pages shown in the preview grid. */
export const PREVIEW_PDF_URL =
  'https://cdn.magicpatterns.com/uploads/6Jm8wVDx4n8fvRpgrbPwC5/Musique_Prete_5_Paginas_Muestra.pdf'

export interface PreviewItem {
  /** 1-based page number inside PREVIEW_PDF_URL. */
  page: number
  alt: string
  caption: string
}

export const previewItems: PreviewItem[] = [
  {
    page: 1,
    alt: 'Page professeur de l’atelier 08 «\u00A0Ma première partition dessinée\u00A0»\u00A0: objectif, modèle rythmique TA et CHUT à afficher, premières étapes et point d’attention',
    caption: 'Atelier guidé · Tome 01, page 18',
  },
  {
    page: 2,
    alt: 'Fiche élève F02 «\u00A0Je compte les frappes\u00A0»\u00A0: deux exercices sur des bandes rythmiques TA et CHUT et un retour sur le travail',
    caption: 'Fiche élève · Tome 01, page 29',
  },
  {
    page: 3,
    alt: 'Cartes-outils 17 à 20 à découper\u00A0: diagnostic, cible, stratégie et vérification',
    caption: 'Cartes-outils · Tome 06, page 40',
  },
  {
    page: 4,
    alt: 'Travail pratique TP1 «\u00A0Le projet musical de deux minutes\u00A0»\u00A0: mission, contrat de réussite et plan de réalisation en cinq sections',
    caption: 'Travail pratique · Tome 10, page 42',
  },
  {
    page: 5,
    alt: 'Corrigé et grille de l’évaluation E2\u00A0: exemple de réalisation et grille à quatre critères notés de 0 à 3',
    caption: 'Corrigé et grille d’évaluation · Tome 10, page 59',
  },
]
